module.exports = {
  /* 01.General */
  "chat.end":"I-restart ang iyong pag-uusap sa chat",
  "chat.endall":"Tapusin ang Chat",
  "chat.cancel":"Kanselahin",
  "chat.cookie":"Gumagamit ang cookies ng digital na ito ng cookies upang matiyak na makukuha mo ang pinakamahusay na karanasan",
  "chat.learn":"Matuto nang higit pa",
  "chat.minimize":"I-minimize",
  "chat.hide":"Isara",
  "chat.hidebot.text":"Ang pagsara ay gagawing mawala ang avatar sa loob ng 15 minuto",
  "chat.hidebot":"Isara ang Bot",
  "chat.restart":"I-restart",
  "switch.language":"Lumipat ng Wika",
  "switch.property":"Lumipat ng Ari-arian",
  "restart.converstation":"I-restart ang Conversation",
  "chat.endtext":"Sigurado ka bang gusto mong tapusin ang kasalukuyang chat?",
  "check.availabity":"Suriin ang Availability",
  "check.availabity.submit":"Ipasa",
  "check.availabity.cancel":"Kanselahin",
  "check.availabity.adults":"Matanda ",
  "check.availabity.children":"Mga bata",
  "check.availabity.child.age":"Edad - Bata",
  "feedback.leave":"Mag-iwan ng opinyon",
  "feedback.leave.message":"Mag-iwan ng mensahe",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
